<script setup lang="ts">
import { onMounted, useTemplateRef } from "vue";

defineProps({
    modelValue: {
        type: String,
        required: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const input = useTemplateRef("input");

function onInput(event: InputEvent) {
    if (event.target) {
        emit("update:modelValue", (event.target as HTMLInputElement).value);
    }
}

onMounted(() => {
    if (input.value?.inputRef?.hasAttribute("autofocus")) {
        input.value?.inputRef?.focus();
    }
});

defineExpose({ focus: () => input.value?.inputRef?.focus() });
</script>

<template>
    <UInput
        ref="input"
        class="border-muted focus:border-primary-500 focus:ring-primary-500 rounded-md shadow-sm"
        :value="modelValue"
        @input="onInput"
    />
</template>

